if (!customElements.get('collection-list-card')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        pagination: '.swiper-pagination',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.cardStyle = this.dataset.cardStyle;
      this.itemSize = this.dataset.itemSize;
      this.columnsDesktop = this.dataset.columnsDesktop;

      this.paginationType = this.dataset.paginationType || 'progressbar';

      this.sliderInstance = false;

      const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      mql.onchange = this.init.bind(this);
      this.init();
    }

    init() {
      //  ⭐ CHANGE #1 → MOBILE પર slider destroy ન કરવો
      // OLD:
      // if (FoxTheme.config.mqlMobile) {
      //   this.destroySlider();
      // } else {
      //   this.initSlider();
      // }

      // NEW:
      this.initSlider();
    }

    initSlider() {
      if (typeof this.sliderInstance === 'object') return;

      let paginationEl = this.section.querySelector(this.selectors.pagination);

      if (!paginationEl && this.paginationType === 'progressbar') {
        const controls = this.section.querySelector('.swiper-controls') || this.section;
        paginationEl = document.createElement('div');
        paginationEl.className = 'swiper-pagination';
        controls.appendChild(paginationEl);
      }

      const sliderOptions = {
        modules: [
          FoxTheme.Swiper.Navigation,
          FoxTheme.Swiper.Pagination,
          FoxTheme.Swiper.Mousewheel
        ],
        slidesPerView: 1.5,
        spaceBetween: 10,

        pagination: {
          el: paginationEl,
          type: this.paginationType,
          clickable: this.paginationType !== 'progressbar',
        },

        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },

        loop: false,
        threshold: 2,

        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },

        breakpoints: {
            481: {
            spaceBetween: this.cardStyle == 'card' ? 10 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? (this.columnsDesktop > 1 ? 2.1 : this.columnsDesktop)
                : 'auto',
          },
             576: {
            spaceBetween: this.cardStyle == 'card' ? 10 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? (this.columnsDesktop > 1 ? 2.5 : this.columnsDesktop)
                : 'auto',
          },
          768: {
            spaceBetween: this.cardStyle == 'card' ? 12 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? (this.columnsDesktop > 1 ? 3 : this.columnsDesktop)
                : 'auto',
          },
          992: {
            spaceBetween: this.cardStyle == 'card' ? 12 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? (this.columnsDesktop > 2 ? 4 : this.columnsDesktop)
                : 'auto',
          },
          1280: {
            spaceBetween: this.cardStyle == 'card' ? 12 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? this.columnsDesktop > 4
                  ? this.columnsDesktop - 1
                  : this.columnsDesktop
                : 'auto',
          },
          1441: {
            spaceBetween: this.cardStyle == 'card' ? 12 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? this.columnsDesktop
                : 'auto',
          },
        },

        observer: true,
        observeParents: true,
        watchOverflow: true,
      };

      this.classList.add(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.grid);
      this.sliderWrapper.classList.add(this.classes.swiperWrapper);

      this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
      this.sliderInstance.init();
    }

    // ⭐ CHANGE #2 → destroySlider() માત્ર explicit call માટે રાખ્યો છે (init માં use નથી થતા)
    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);

      if (typeof this.sliderInstance !== 'object') return;

      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }

  customElements.define('collection-list-card', CollectionList);
}
